import { Edit2, Trash2, CheckCircle, Eye } from 'lucide-react';

const DataTable = ({ columns, data, onEdit, onDelete, onView, hideEdit = false, loading = false }) => {
  if (loading) {
    return (
      <div className="table-container">
        <table className="common-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col.header}</th>
              ))}
              <th style={{ width: '100px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((_, colIndex) => (
                  <td key={colIndex}>
                    <div style={{
                      height: '16px',
                      background: '#EAECEF',
                      borderRadius: '4px',
                      width: '70%',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }} />
                  </td>
                ))}
                <td>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <div style={{
                      height: '28px',
                      width: '28px',
                      background: '#EAECEF',
                      borderRadius: '6px',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }} />
                    <div style={{
                      height: '28px',
                      width: '28px',
                      background: '#EAECEF',
                      borderRadius: '6px',
                      animation: 'pulse 1.5s infinite ease-in-out'
                    }} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <style dangerouslySetInnerHTML={{
          __html: `
          @keyframes pulse {
            0% { opacity: 0.6; }
            50% { opacity: 1; }
            100% { opacity: 0.6; }
          }
        `}} />
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="common-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col.header}</th>
            ))}
            <th style={{ width: '100px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 1} style={{ textAlign: 'center', padding: '32px', color: 'var(--text-secondary)' }}>
                No records available
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => {
                  const val = row[col.accessor];
                  return (
                    <td key={colIndex}>
                      {col.render 
                        ? col.render(row) 
                        : (val !== undefined && val !== null && String(val).trim() !== '' ? val : 'N/A')}
                    </td>
                  );
                })}
                <td>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {!hideEdit && (
                      <button
                        className="action-btn"
                        title="Edit"
                        onClick={() => onEdit(row, rowIndex)}
                      >
                        <Edit2 size={16} />
                      </button>
                    )}
                    {onView && (
                      <button
                        className="action-btn"
                        style={{ color: '#007BFF' }}
                        title="View Details"
                        onClick={() => onView(row, rowIndex)}
                      >
                        <Eye size={16} />
                      </button>
                    )}
                    <button
                      className="action-btn"
                      style={{ color: '#FF4D4D' }}
                      title="Delete"
                      onClick={() => onDelete(row)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
